import { ElementWithProps, createComponent } from '@carvana/merch-components';
import cx from 'classnames';

export const ImageWrapper = createComponent('div', {
  className:
    'flex-0 flex h-72 w-full max-w-72 justify-center rounded-md bg-grey-1'
});

export const TradeValue = createComponent('p', {
  className: 'flex flex-shrink-0 items-center tl-header-m'
});

export const YearMakeModel = createComponent<
  ElementWithProps<{ showValue: boolean }>
>('p', ({ showValue }) => ({
  className: cx('tl-header-s', {
    'w-full truncate': showValue
  })
}));

export const DetailsWrapper = createComponent('div', {
  className: 'grid w-full grid-rows-[auto_auto] gap-4'
});
